module.exports = __webpack_public_path__ + "img/53.24d4203e.jpg";